import { createApp } from 'vue'
import App from '@/page/vue/2023/guinness.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计
import { Button, Grid, GridItem } from 'vant'
import { ConfigProvider } from 'vant'

import 'vant/lib/index.css'

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: 'ISC 2023挑战吉尼斯世界纪录',
  desc: '全球共书新安全，只等你来！',
  imgUrl: 'https://p2.qhimg.com/t015644243d957468c9.png',
  link: window.location.href
})
const IS_H5 = /Android|webOS|iPhone|iPad|IEMobile|Opera Mini/i.test(navigator.userAgent)
if (!IS_H5) {
  const baseSize = 16 // 基准大小
  let real = baseSize.toFixed(3) * (document.documentElement.clientWidth / 1920)
  console.log('fontsize', real + 'px')
  document.documentElement.style.fontSize = `${real}px`
} else {
  var count = 375 / 10
  document.documentElement.style.fontSize = document.documentElement.clientWidth / count + 'px'
  console.log('fontsize', document.documentElement.clientWidth / count + 'px')
}
const app = createApp(App)
app.use(Grid).use(GridItem).use(Button).use(ConfigProvider)
app.mount('#app')
